var _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyBySymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.75H20.25V3.75H8.25V8.25",
    stroke: "#21BB8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.25H3.75V20.25H15.75V8.25Z",
    stroke: "#21BB8E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 17.5,
    r: 5.5,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 24C19.0899 24 22 21.0899 22 17.5C22 13.9101 19.0899 11 15.5 11C11.9101 11 9 13.9101 9 17.5C9 21.0899 11.9101 24 15.5 24ZM15.792 22.05H15.209V21.2573C13.812 21.1649 12.9589 20.3829 12.8771 19.2631H13.7871C13.8511 19.9954 14.4625 20.3793 15.209 20.4575V17.7666L14.9246 17.6848C13.7871 17.3578 13.0762 16.7748 13.0762 15.7938C13.0762 14.6776 13.9898 13.9027 15.209 13.7782V12.95H15.792V13.7676C17.0788 13.8529 17.9888 14.642 18.0243 15.68H17.1712C17.093 15.033 16.5456 14.6278 15.792 14.5532V17.0805L16.0764 17.1588C16.83 17.3578 18.1239 17.7986 18.1239 19.1636C18.1239 20.2727 17.285 21.1542 15.792 21.2573V22.05ZM15.792 17.9337V20.4575C16.6522 20.3615 17.2707 19.8639 17.2707 19.1494C17.2707 18.4242 16.5882 18.1541 15.8204 17.9408L15.792 17.9337ZM13.9293 15.7511C13.9293 16.4727 14.6687 16.7713 15.209 16.9241V14.5638C14.427 14.6669 13.9293 15.1361 13.9293 15.7511Z",
    fill: "#21BB8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBySymbol);
export default __webpack_public_path__ + "static/media/copy-by-symbol.7286653d.svg";
export { ForwardRef as ReactComponent };